//Require API JS
require('../../api/tyres/_lookup');

//Require tyres JS
require('./_loop-item');
require('./_search');
require('./_results');
require('./_refine');
require('./_tooltip');
require('./_enquire');
require('./_read-tyre-modal');
require('./_child');
require('./_sizes');
require('./_nearest-branch');
require('./_load-more');